/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminLearnMoreControllerDeleteLearnMoreV1$Params {
  id: string;
}

export function adminLearnMoreControllerDeleteLearnMoreV1(http: HttpClient, rootUrl: string, params: AdminLearnMoreControllerDeleteLearnMoreV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminLearnMoreControllerDeleteLearnMoreV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

adminLearnMoreControllerDeleteLearnMoreV1.PATH = '/v1/admin/learn-more/{id}';
